import string from "../locales";

export default function getText(userLanguage, room, text) {
  if (room !== "") {
    return string["ko"]?.[text];
  }
  return string[userLanguage]?.[text];
}
